/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// START: Update variant selection on featured variant image click

const selectVariantByClickingImage = {
  // Create variant images from productJson object
  // Required in main-product.liquid or product-variant-selector.liquid <script type="application/json" id="ProductJson-{{ section.id }}">{{ product | json }}</script>
  _createVariantImage: function (product) {
    const variantImageObject = {};
    product.variants.forEach((variant) => {
      if (variant.image || (variant.featured_image && variant.featured_image.src)) {
        const variantImage = new URL(variant.featured_image.src, window.location.origin).pathname;
        variantImageObject[variantImage] = variantImageObject[variantImage] || {};
  
        product.options.forEach((option, index) => {
          const optionValue = variant.options[index];
          const optionKey = `option-${index}`;
          if (typeof variantImageObject[variantImage][optionKey] === 'undefined') {
            variantImageObject[variantImage][optionKey] = optionValue;
          } else {
            const oldValue = variantImageObject[variantImage][optionKey];
            if (oldValue !== null && oldValue !== optionValue) {
              variantImageObject[variantImage][optionKey] = null;
            }
          }
        });
      }
    });
  //   console.log("Generated variantImages object:", variantImageObject);
    return variantImageObject;
  },  
  _updateVariant: function (event, id, product, variantImages) {
  //   console.log("Image clicked, event triggered!", event.target);
    const img = event.target.closest('button')?.querySelector('img') || event.target.closest('img') || event.target;
    if (!img) {
      // console.log("No image found inside button.");
      return;
    }
    // Normalize image path to match stored variant images
    let imgSrc = new URL(img.src, window.location.origin).pathname;
    // console.log("Processed image path:", imgSrc);
    // console.log("Available image keys in variantImages:", Object.keys(variantImages));
  
    if (variantImages[imgSrc]) {
      // console.log("Variant match found:", variantImages[imgSrc]);
  
      // Get the variant name (color, size, etc.)
      const selectedVariant = variantImages[imgSrc]['option-0'];
      // console.log(`Trying to select variant: ${selectedVariant}`);
  
      if (!selectedVariant) {
        console.warn("No valid variant found for this image.");
        return;
      }

      // 1. Handle Swatch Selection by Matching the Color Name
      const swatchList = document.querySelector('.product-form__option .color-swatch-list');
      if (swatchList) {
        // console.log("Swatch list found, looking for matching swatch...");
        // Loop through swatches and check if the `title` matches the selectedVariant
        const matchingSwatch = Array.from(swatchList.querySelectorAll('.color-swatch')).find(swatch => {
          const swatchTitle = swatch.querySelector('label').getAttribute('title');
          return swatchTitle === selectedVariant; // Match the title of the swatch
        });

        if (matchingSwatch) {
          // console.log("Found matching swatch:", matchingSwatch);
          const swatchInput = matchingSwatch.querySelector('input[type="radio"]');
          if (swatchInput) {
            swatchInput.checked = true;
            swatchInput.dispatchEvent(new Event("change", { bubbles: true }));
            return;
          }
        } else {
          console.warn(`No matching swatch found for variant: ${selectedVariant}`);
        }
      }

      // 2. Fallback to Dropdown if no swatches
      const variantDropdown = document.querySelector(`select.product-form__single-selector`);
      if (variantDropdown) {
        // console.log("Dropdown found:", variantDropdown); 

        const matchingOption = Array.from(variantDropdown.options).find(
          option => option.text.includes(selectedVariant)
        );

        if (matchingOption) {
          // console.log("Matching option found in dropdown:", matchingOption);
  
          variantDropdown.value = matchingOption.value;
  
          // Trigger change event
          variantDropdown.dispatchEvent(new Event("change", { bubbles: true }));
        } else {
          console.warn(`No matching option found for variant: ${selectedVariant}`);
        }
      } else {
        console.warn("No variant dropdown found on page.");
      }
    } else {
      // console.log("No variant match for image:", imgSrc);
    }
  },  
  _selectVariant: function() {
    const productJson = document.querySelectorAll('[id^=ProductJson-]');
    // console.log("Found ProductJson elements:", productJson);
    
    if (productJson.length > 0) {
      productJson.forEach((product) => {
        const sectionId = product.id.replace("ProductJson-", "shopify-section-");
        // console.log("Processing section:", sectionId); 

        const thumbnails = document.querySelectorAll('#' + sectionId + ' .product-gallery__thumbnail-list img[src*="/cdn/"]');
        // console.log("Thumbnails found:", thumbnails);
        
        if (thumbnails.length > 1) {
          const productObject = JSON.parse(product.innerHTML);
          const variantImages = this._createVariantImage(productObject);

          if (productObject.variants.length > 1) {
            thumbnails.forEach((thumbnail) => {
              const button = thumbnail.closest('a'); // Get the closest <a> ancestor
              if (button) {
                // console.log("Adding event listener to:", button);
                button.addEventListener('click', (e) => {
                  const img = button.querySelector('img'); // Get the image inside the button
                  if (img) {
                    this._updateVariant({ target: img }, sectionId, productObject, variantImages);
                  }
                });
              }
            });
          }
        }
      });
    }
  },
};

if (document.readyState !== 'loading') {
  selectVariantByClickingImage._selectVariant();
} else {
  document.addEventListener(
    'DOMContentLoaded',
    selectVariantByClickingImage._selectVariant,
  );
}
    
// END: Update variant selection on featured variant image click